var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12L2.3753 11.5002L1.9755 12L2.3753 12.4998L3 12ZM12 12.8C12.4418 12.8 12.8 12.4418 12.8 12C12.8 11.5582 12.4418 11.2 12 11.2V12.8ZM6.3753 6.50024L2.3753 11.5002L3.6247 12.4998L7.62469 7.49976L6.3753 6.50024ZM2.3753 12.4998L6.3753 17.4998L7.62469 16.5002L3.6247 11.5002L2.3753 12.4998ZM3 12.8H12V11.2H3V12.8Z",
    fill: "#FC7B52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.5V8.02985C11 6.54308 11 5.7997 11.4063 5.26385C11.4447 5.2132 11.4854 5.16442 11.5285 5.11766C11.9839 4.6229 12.7155 4.49121 14.1788 4.22782V4.22782C17.2212 3.68019 18.7423 3.40638 19.7832 4.17568C19.8795 4.24685 19.9714 4.32371 20.0585 4.40586C21 5.29394 21 6.83958 21 9.93086V14.0691C21 17.1604 21 18.7061 20.0585 19.5941C19.9714 19.6763 19.8795 19.7532 19.7832 19.8243C18.7423 20.5936 17.2212 20.3198 14.1788 19.7722V19.7722C12.7155 19.5088 11.9839 19.3771 11.5285 18.8823C11.4854 18.8356 11.4447 18.7868 11.4063 18.7362C11 18.2003 11 17.4569 11 15.9702V15.6594",
    stroke: "#FC7B52",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.5122bb751816605088d7b7c98db8e105.svg";
export { ForwardRef as ReactComponent };